<template>
  <!-- <el-scrollbar wrap-class="scrollbar-wrapper"> -->
  <el-menu :default-active="activeMenu" :collapse="isCollapse" :unique-opened="true" :collapse-transition="false" mode="vertical">
    <sidebar-item v-for="(route, index) in sidebarRouters" :key="route.path  + index" :item="route" :base-path="route.path" />
  </el-menu>
  <!-- </el-scrollbar> -->
</template>

<script>
import { mapGetters, mapState } from "vuex";
import SidebarItem from "./sideBarItem";

export default {
  components: { SidebarItem },
  props: {
    sidebarRouters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {

    }
  },
  computed: {
    ...mapGetters(["sidebar"]),
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    isCollapse() {
      return !this.sidebar.opened;
    },
  },
  mounted() { }
};
</script>

<style lang="less" scoped>
/deep/ .scrollbar-wrapper {
  min-height: 300px;
}
.el-menu {
  border: none;
  background-color: transparent !important;
  /deep/ .el-menu-item,
  /deep/ .el-submenu__title {
    border-radius: 8px;
    font-size: 16px;
  }
  /deep/ .el-menu-item.is-active {
    background: #2960a7;
    color: #fff;
  }
}
/deep/ .el-submenu .el-menu {
  border: none;
  background-color: transparent !important;
  /deep/ .el-menu-item,
  /deep/ .el-submenu__title {
    border-radius: 8px;
    font-size: 16px;
  }
  /deep/ .el-menu-item.is-active {
    background: #2960a7;
    color: #fff;
  }
}

@media screen and (max-width: 768px) {
  /deep/ .scrollbar-wrapper {
    min-height: auto;
  }
  .el-menu {
    border: none;
    background-color: transparent !important;
    /deep/ .el-menu-item,
    /deep/ .el-submenu__title {
      border-radius: 6px;
      font-size: 14px;
      height: 46px;
      line-height: 46px;
    }
    /deep/ .el-menu-item.is-active {
      background: #2960a7;
      color: #fff;
    }
  }
  /deep/ .el-submenu .el-menu {
    border: none;
    background-color: transparent !important;
    /deep/ .el-menu-item,
    /deep/ .el-submenu__title {
      border-radius: 6px;
      font-size: 14px;
      height: 46px;
      line-height: 46px;
    }
    /deep/ .el-menu-item.is-active {
      background: #2960a7;
      color: #fff;
    }
  }
}
</style>
